export default __webpack_public_path__ + "static/media/Google_G_Logo.66ae25be.svg";